import type React from 'react';
import { useShortcutScope, VOID_CONFIRM_SCOPE } from '@/components/shortcuts';

/**
 * Pushed only while the void-confirm dialog is open, suspending the rest of
 * the `seller` scope so no sale-screen shortcut fires underneath it — mirrors
 * `CategoryFilterScope` in `CategoryFilter.tsx`. A named sibling of
 * `VoidConfirmDialog.tsx` rather than a second component in that file (rulebook
 * §5.2 — `CheatSheetScope`/`CategoryFilterScope` are registered violations of
 * this, not the pattern to repeat).
 */
export const VoidConfirmScope: React.FC = () => {
    useShortcutScope(VOID_CONFIRM_SCOPE);
    return null;
};
